import React from 'react';
import { AnonymousHeader } from '@components/layout/AnonymousHeader';
import { AnonymousFooter } from '@components/layout/AnonymousFooter';

interface PublicBookingLayoutProps {
  maxWidth?: 'md' | '2xl';
  children: React.ReactNode;
}

export const PublicBookingLayout: React.FC<PublicBookingLayoutProps> = ({
  maxWidth = 'md',
  children,
}) => (
  <div className="min-h-screen bg-gradient-to-br from-primary-500 via-secondary-500 to-primary-600 flex flex-col">
    <AnonymousHeader />
    <div className="flex-1 flex items-center justify-center p-4">
      <div className={`w-full ${maxWidth === 'md' ? 'max-w-md' : 'max-w-2xl'}`}>{children}</div>
    </div>
    <AnonymousFooter />
  </div>
);

interface StatusIconProps {
  icon: string;
  tone?: 'primary' | 'success' | 'error';
}

const TONES = {
  primary: 'from-primary-500 to-secondary-500',
  success: 'from-green-500 to-green-600',
  error: 'from-red-500 to-red-600',
} as const;

export const StatusIcon: React.FC<StatusIconProps> = ({ icon, tone = 'primary' }) => (
  <div
    className={`mx-auto mb-6 w-16 h-16 bg-gradient-to-r ${TONES[tone]} rounded-full flex items-center justify-center`}
  >
    <span className="material-icons text-2xl text-white">{icon}</span>
  </div>
);
